import SectionMessage from '@atlaskit/section-message';

export * from '@atlaskit/section-message';

export default SectionMessage;
